// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Total_wrapper_1Bs4Y","totalText":"Total_totalText_1Kmqp","values":"Total_values_1cCXq","cell":"Total_cell_vhVtl","value":"Total_value_3XP9a","empty":"Total_empty_3t2To"};